import { useEffect, useState } from "react";
import BSNavbar from "../../component/Navbar/Navbar";
import CommentItem from "../../component/CommentItem/CommentItem";
import { FaSearch } from 'react-icons/fa'
import FadeLoader from "react-spinners/FadeLoader";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { update } from "../../features/searchKeyword/searchKeyword";
import { searchKeyword } from "../../features/searchKeyword/searchKeyword";
import { Pagination, Form } from "react-bootstrap";
import { BsArrowRightCircleFill } from 'react-icons/bs'
import { selectWindowWidth } from "../../features/windowWidth/windowWidth";
import './Comment.css'

const search_api_url = process.env.REACT_APP_API_URL + "/comments/search";
const max_page_api_url = process.env.REACT_APP_API_URL + "/comments/pages";

const Comment = () => {
  const [comment, setComment] = useState([]);
  const [nowPage, setNowPage] = useState(1);
  const [maxPage, setMaxPage] = useState(22);
  const [localSearch, setLocalSearch] = useState('');
  const searchKey = useSelector(searchKeyword);
  const [searchTrigger, setSearchTrigger] = useState(false);
  const [loading, setLoading] = useState(false);
  const windowWidth = useSelector(selectWindowWidth);
  const dispatch = useDispatch();

  const searchComments = async (page) => {
    setLoading(true);
    const response = await fetch(`${search_api_url}?q=${searchKey}&page=${page - 1}`).then(res => res.json());
    if (response.length === 0) {
      alert('搜尋不到，請嘗試其他關鍵字><');
      setLoading(false);
      return;
    }
    if (searchKey.length > 0) {
      const reversed = response.reverse();
      setComment(reversed);
    } else {
      setComment(response);
    }
    setLoading(false);
  }

  /* Ideal way */
  const getMaxPage = async () => {
    const response = await fetch(max_page_api_url).then(res => res.json());
    console.log(response.maxPages)
    setMaxPage(response.maxPages);
  }

  /* Now we are using this */
  const uglyGetMaxPage = async () => {
    let page = 1;
    while (true) {
      const response = await fetch(`${search_api_url}?q=${searchKey}&page=${page - 1}`).then(res => res.json());
      if (response.length < 30) {
        if (response.length > 0) setMaxPage(page);
        else setMaxPage(page - 1);
        break;
      }
      page++;
    }
  }

  useEffect(() => {
    const controller = new AbortController();

    searchComments(1);
    setLocalSearch(searchKey);

    return () => controller.abort();
  }, [searchTrigger, searchKey])

  useEffect(() => {
    const controller = new AbortController();

    if (searchKey.length === 0) {
      searchComments(nowPage);
      getMaxPage();
    }

    return () => controller.abort();
  }, [nowPage])

  const handleSearch = () => {
    dispatch(update(localSearch));
    setSearchTrigger(!searchTrigger);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch();
  }

  if (loading) {
    return (
      <div style={{ background: '#dfd8cd', height: '100vh' }}>
        <BSNavbar bg={'#dfd8cd'} />
        <FadeLoader
          color="#4b3615"
          loading={true}
          size={150}
          aria-label="Loading Spinner"
          data-testid="loader"
          style={{ position: 'absolute', top: '50%', left: '50%' }}
        />
      </div>
    )
  } else {
    return (
      <div style={{ background: '#dfd8cd', minHeight: '100vh', paddingBottom: '20px' }}>
        <BSNavbar bg={'#dfd8cd'} />
        <Form onSubmit={handleSubmit} className='comment-input ms-auto me-auto mb-3 mt-4'
          style={{
            width: windowWidth < 900 ? '90%' : '80%',
            height: '50px'
          }}>
          <FaSearch size={20} />
          <Form.Control
            style={{ fontSize: '20px' }}
            placeholder="關鍵字..."
            autoFocus
            onChange={(e) => setLocalSearch(e.target.value)}
            className="comment-search-tag"
            value={localSearch}
          />
          <BsArrowRightCircleFill
            size={30}
            className="me-2 comment-send-icon"
            onClick={handleSearch}
            type="submit"
          />
        </Form>
        {comment.map((ele, id) => (
          <CommentItem ele={ele} key={id} variant='all-comment' />
        ))}

        {(maxPage > 1 && searchKey.length === 0) &&
          <div style={{ display: 'flex' }}>
            <Pagination style={{ margin: 'auto', marginBottom: '30px', marginTop: '20px' }}>
              <Pagination.First onClick={() => setNowPage(1)} />
              <Pagination.Prev onClick={() => { nowPage > 1 && setNowPage(nowPage - 1) }} />
              {nowPage > 2 && <Pagination.Item onClick={() => setNowPage(1)}>1</Pagination.Item>}
              {nowPage > 3 && <Pagination.Ellipsis disabled />}
              {nowPage > 1 && <Pagination.Item onClick={() => setNowPage(nowPage - 1)}>{nowPage - 1}</Pagination.Item>}
              <Pagination.Item active onClick={() => setNowPage(nowPage)}>{nowPage}</Pagination.Item>
              {nowPage < maxPage && <Pagination.Item onClick={() => setNowPage(nowPage + 1)}>{nowPage + 1}</Pagination.Item>}
              {nowPage < (maxPage - 2) && <Pagination.Ellipsis disabled />}
              {nowPage < (maxPage - 1) && <Pagination.Item onClick={() => setNowPage(maxPage)}>{maxPage}</Pagination.Item>}
              <Pagination.Next onClick={() => { nowPage < maxPage && setNowPage(nowPage + 1) }} />
              <Pagination.Last onClick={() => setNowPage(maxPage)} />
            </Pagination>
          </div>
        }
      </div >
    )
  }
}

export default Comment;